export const SOCKET_EVENTS = {
    CS_JoinRoom: '0xff0001',
    CS_Move: '0xff0002',
    CS_Draw: '0xff0003',
    CS_Resign: '0xff0004',
    CS_JoinPvBotRoom: '0xff0005',
    CS_BotMove: '0xff0006',
    CS_CloseRoom: '0xff0008',
    CS_JoinFriendRoom: '0xff000a',
    CS_GetWaitingFriends: '0xff000c',
    CS_Online: '0xff000d',
    CS_TimeoutRes: '0xff000e',
    CS_WonByBtn: '0xff0011',
    CS_UpdateSocketId: '0xff0012',
    CS_UpdateUserState: '0xff0013',
    CS_CastSpell: '0xff0014',
    CS_ItemUseUpdate: '0xff0015',
    SC_ChessyMoves: '0xff0016',
    CS_CentristMove: '0xff0017',
    CS_CollectBoardItem: '0xff0018',
    CS_ClaimQuickWin: '0xff0019',
    SC_RoomJoined: '0x00ff01',
    SC_Move: '0x00ff02',
    SC_Count: '0x00ff03',
    SC_WaitingFriends: '0x00ff0c',
    SC_UpdateSocketId: '0x00ff0e',
    SC_HeroPower: '0x00ff0f',
    SC_RewindMove: '0x00ff11',
    SC_CastSpell: '0x00ff12',
    SC_ResetUser: '0x00ff13',
    SC_Logout: '0x00ff14',
    SC_BoardItemCollected: '0x00ff15',
    SC_TournamentStandings: '0x00ff16',
    SC_GameFinished: '0x00ff17',
    SC_OpponentConvertedToBot: '0x00ff18',
    SC_QuickWinClaimable: '0x00ff19',
    SC_QuickWinClaimRejected: '0x00ff1a',
    SC_TimeoutPending: '0x00ff1b',
    ADMIN_GET_NO_USERS: '0x000002',
    ADMIN_DISCONNECT_USER: '0x000003',
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    CONNECT_ERROR: 'connect_error',
    DISCONNECTING: 'disconnecting'
};
export const SOCKET_ERRORS = {
    PING_TIMEOUT: 'ping timeout',
    TRANSPORT_ERROR: 'transport error'
};
//# sourceMappingURL=events.js.map